export default __webpack_public_path__ + "static/bg-b70809811eb58458df1488f7c9b1f7f5.mp4";